import { SVGProps } from "react"
const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.41176 16.8897L3 12.2574M3 12.2574L7.41176 7.625M3 12.2574H21"
      stroke={props.color as string | "white"}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default ArrowIcon
